import { connect } from 'react-redux';

import { getEvents } from '../actions/events';

import AdminEventsListPageComponent from '../components/AdminEventsListPage';

const mapStateToProps = state => {
  return {
    events: [],
  };
};

const mapDispatchToProps = dispatch => {
  return { 
    getEvents: () => dispatch(getEvents()),
  };
};

const AdminEventsListPage = connect(mapStateToProps, mapDispatchToProps)(AdminEventsListPageComponent);

export default AdminEventsListPage;
